<template>
  <v-container>
    <FormRow
      label="Power Down Delay on ACC OFF (0-1440 mins)"
      :input-payload="powerDownTimer"
      :rules="powerDownTimerRules"
      @parseNewVAl="parseNewVal($event, 'powerDownTimer', 'Power / Power Down Delay on ACC OFF')"
    />
     <FormRow
      label="Low Voltage Power Down Threshold (8-11.5V)"
      :input-payload="powerDownThreshold"
      :dropdown="true"
      :options="voltageMap"
      @parseNewVAl="parseNewVal($event, 'powerDownThreshold', 'Power / Low Voltage Power Down Threshold')"
    />
    <FormRow 
      label="Enable Daily Reboot"
      :input-payload="dailyReboot"
      :check-box="true"
      @parseNewVAl="parseNewVal($event, 'dailyReboot', 'Power / Enable Daily Reboot')"
    />
    <v-row>
      <v-col cols="4" class="no-padding align-vertical">
        <div>Daily Reboot Time (24 hour format HH:MM):</div>
      </v-col>
      <v-col cols="8" class="no-padding align-vertical">
        <vue-timepicker v-if="hasTimeBeenSet" v-model="time" @change="setTime"></vue-timepicker>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>

import FormRow from '../components/FormRow.vue';

import {deviceConfigMixin} from '@/mixins/deviceConfigMixin.js';

import { checkIfVersionIsAboveLimit } from '@/utils';

import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'

// import { Logger } from "aws-amplify";
// const logger = new Logger("App");

export default {
  name: 'Power',
  components: {
    FormRow,
    VueTimepicker
  },
  mixins: [deviceConfigMixin],
  props: {
    config: {
      type: Object,
      required: true
    },
    firmwareVersion: {
      type: String,
      required: true
    },
    deviceModel: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      time: {
        HH: '',
        mm: ''
      },
      voltageFirmwareMap: {
        'CAMERAMATICS_D700-SD-4G': {
          from: '01.01.34',
          to: '9.99.99'
        },
        'CAMERAMATICS_JH4-HD-4G': {
          from: '01.01.34',
          to: '9.99.99'
        },
        'CAMERAMATICS_JH8-HD-4G': {
          from: '01.00.49',
          to: '9.99.99'
        },
        'CAMERAMATICS_JH8_NT-HD-4G': {
          from: '01.01.34',
          to: '9.99.99'
        },
        'CAMERAMATICS_JH4_NT-HD-4G': {
          from: '01.01.34',
          to: '9.99.99'
        },
        'CAMERAMATICS_JI7A-SD-4G': {
          from: '0.00.00',
          to: '9.99.99'
        }
      },
      manualTimeChange: 0
    }
  },
  computed: {
    powerDownTimer() {
      return this.config.device_config.system[0].power[0].acc[0].powerDownDelay[0];
    },
    powerDownThreshold() {
      return this.config.device_config.system[0].power[0].lowVoltage[0].powerDownThreshold[0];
    },
    dailyReboot() {
      return JSON.parse(this.config.device_config.system[0].power[0].autoreboot[0].enable[0].toLowerCase());
    },
    rebootTime() {
      return this.config.device_config.system[0].power[0].autoreboot[0].time[0];
    },
    powerDownTimerRules() {
      return [
        v => !!v || 'This field is required',
        v => !isNaN(parseFloat(v)) && v >= 0 && v <= 1440 || 'Number has to be between 0 and 1440'
      ]      
    },
    hasTimeBeenSet() {
      return this.time.HH != '' || this.time.mm != '' ? true : false;
    },
    voltageMap() {
      const map = [
        {
          xml: '8',
          label: '8.0'
        },
        {
          xml: '8.5',
          label: '8.5'
        },
        {
          xml: '9',
          label: '9.0'
        },
        {
          xml: '9.5',
          label: '9.5'
        },
        {
          xml: '10',
          label: '10.0'
        },
        {
          xml: '10.5',
          label: '10.5'
        },
        {
          xml: '11',
          label: '11.0'
        },
        {
          xml: '11.5',
          label: '11.5'
        }
      ];
      const extendedMap = [
        {
          xml: '8',
          label: '8.0'
        },
        {
          xml: '8.5',
          label: '8.5'
        },
        {
          xml: '9',
          label: '9.0'
        },
        {
          xml: '9.5',
          label: '9.5'
        },
        {
          xml: '10',
          label: '10.0'
        },
        {
          xml: '10.5',
          label: '10.5'
        },
        {
          xml: '11',
          label: '11.0'
        },
        {
          xml: '11.5',
          label: '11.5'
        },
        {
          xml: '20.0',
          label: '20.0'
        },
        {
          xml: '20.0',
          label: '20.0'
        },
        {
          xml: '20.5',
          label: '20.5'
        },
        {
          xml: '21.0',
          label: '21.0'
        },
        {
          xml: '21.5',
          label: '21.5'
        },
        {
          xml: '22.0',
          label: '22.0'
        },
        {
          xml: '22.5',
          label: '22.5'
        },
        {
          xml: '23.5',
          label: '23.5'
        }
      ]
      if(this.firmwareVersion == '') return map;
      
      const supportsExtendedMap = checkIfVersionIsAboveLimit(this.firmwareVersion, this.voltageFirmwareMap[this.deviceModel]['from']);
      
      if (supportsExtendedMap) return extendedMap;
      else if (!supportsExtendedMap) return map;
      else return map;
    }
  },  
  mounted() {
    this.convertMinstoHrs(this.rebootTime);
  },
  methods: {
    setTime() {
      this.manualTimeChange++;
      const time = this.convertHrstoMins();

      // Prevent the global config object from being updated on component mount 
      // as it was listing the change in review config modal
      if (this.manualTimeChange < 2) return;
      this.parseNewVal(time, 'rebootTime', 'Power / Daily Reboot Time');
    },
    parseNewVal(val, id, label) {
      let payload = {
        newValue: this.returnMappedVal(val, [this.voltageMap]),
        key: this.configPropMapper(id),
        label: label
      }

      this.$emit('settingsUpdated', payload);
    },
    configPropMapper(key) {
      let map = {
        'powerDownTimer': `device_config.system[0].power[0].acc[0].powerDownDelay[0]`,
        'powerDownThreshold': `device_config.system[0].power[0].lowVoltage[0].powerDownThreshold[0]`,
        'dailyReboot': `device_config.system[0].power[0].autoreboot[0].enable[0]`,
        'rebootTime': `device_config.system[0].power[0].autoreboot[0].time[0]`
      }

      return map[key];
    },
    convertMinstoHrs(minutes) {
      var h = Math.floor(minutes / 60);
      var m = minutes % 60;
      
      h = h < 10 ? '0' + h : h;
      m = m < 10 ? '0' + m : m;

      this.time.HH = h.toString();
      this.time.mm = m.toString();
    },
    checkEmptyTimeString(time) {
      return time ? time : '00';
    },
    convertHrstoMins() {
      let hms = parseInt(this.checkEmptyTimeString(this.time.HH)) + ':' + parseInt(this.checkEmptyTimeString(this.time.mm));
      let a = hms.split(':'); // split it at the colons

      // Hours are worth 60 minutes.
      let minutes = (+a[0]) * 60 + (+a[1]);

      return minutes;
    }
  }
}
</script>